import { Container, Heading } from '@hover/blueprint';
import React from 'react';

const ExteriorContractorsHeaderDescription: React.FC = () => (
  <Container maxW="960px" center px={500} mb={{ base: '72px', desktop: 1100 }}>
    <Heading
      size={{ base: 500, tablet: 600, desktop: 700 }}
      textAlign="center"
      fontWeight={{ base: 600, desktop: 600 }}
      style={{ marginBottom: 24 }}
    >
      HOVER saves you time, money and unnecessary headaches.
    </Heading>
    <Heading
      size={{ base: 200, desktop: 500 }}
      textAlign="center"
      fontWeight={{ base: 400, desktop: 400 }}
    >
      We help you connect and collaborate with homeowners, to make jobs simpler
      and more transparent. We offer direct ordering, production management,
      remote measurements and automated estimates to make jobs more cost
      effective and more efficient.
    </Heading>
  </Container>
);

export default ExteriorContractorsHeaderDescription;
